import React from 'react';
import PropTypes from 'prop-types';

import BaseOnOff from '@adsk/bim360-matrix-react-base-on-off';

import './_Checkbox.scss';

/**
 * A Checkbox button for indicating on/off status
 */
export default class Checkbox extends BaseOnOff {
  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);
    this.renderInnerComponent = this.renderInnerComponent.bind(this);
  }

  /**
   * renderInnerComponent
   */
  renderInnerComponent() {
    return (
      <div className="Checkbox__inner-container">
        <div className="Checkbox__inner" />
        {this.props.label && <span className="Checkbox__label">{this.props.label}</span>}
      </div>
    );
  }

  /**
   * render
   */
  render() {
    return super.render('Checkbox', this.renderInnerComponent);
  }
}

Checkbox.propTypes = {
  ...BaseOnOff.propTypes,
  label: PropTypes.node
};
